import React from "react";

const CallToActionSecond = () => {
  return (
    <section className="bg-white text-black py-16 px-6 md:px-24">
      <div className="container mx-auto flex flex-col lg:flex-row items-center gap-12">

        {/* Left Content */}
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent mb-6">
            Premium Sports Infrastructure for Every Arena
          </h2>

          <p className="text-xl mb-10 text-gray-700 leading-relaxed">
            ZajraGreen specializes in constructing world-class football turfs, box cricket arenas, 
            multi-sport courts, and recreational surfaces. Our installations are engineered for
            durability, performance, and long-term usability — trusted by academies, schools,
            sports clubs, and commercial arenas across India.
          </p>

          <h5 className="mb-8 text-lg md:text-xl text-gray-800">
            High-quality materials • Skilled installation • Long-lasting performance
          </h5>

          <button
            className="bg-green-600 text-white font-semibold py-3 px-6 rounded-lg shadow hover:bg-green-700 transition-colors duration-300"
          >
            Get a Free Quote
          </button>
        </div>

        {/* Right Image (unchanged as you said) */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src="/Images/Image_man hitting_football.png"
            alt="Turf Construction Preview"
            className="w-full max-w-4xl h-64 md:h-80 lg:h-[500px] rounded-lg shadow-lg object-cover"
          />
        </div>

      </div>
    </section>
  );
};

export default CallToActionSecond;
